import { Component, OnInit } from '@angular/core';
import { Entreprise } from "../models/entreprise.model";
import { PortfolioService } from '../portfolio.service';
import { Config } from 'protractor';
import { Router } from '@angular/router';

@Component({
  selector: 'app-portfolio',
  templateUrl: './portfolio.component.html',
  providers: [PortfolioService],
  styleUrls: ['./portfolio.component.css']
})
export class PortfolioComponent implements OnInit {
  entreprise: Entreprise;
  entreprises: Entreprise[];
  error: any;

  constructor(private portfolioService: PortfolioService, private router: Router) {
  }

  searchText: string = "";
  filtres: string[];

  checkboxToSearchBar(tags) {
    console.log(tags);
    this.searchText = tags;
  }
  onChange(newValue) {
    console.log(newValue);
  }

  onClick(id) {
    this.router.navigate([`/${id}`]);
  }

  ngOnInit() {
    this.portfolioService.getEntreprises()
      .subscribe(entreprises => this.entreprises = entreprises
      );
    this.portfolioService.getTags()
      .subscribe(filtres => this.filtres = filtres.toString().split(","));
  }

}
